import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  guards: {
    guest: { action: 'block' }
  }
} satisfies RecursivePartial<DialogConfig['welcome']>
